import React from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';
//
import LogoSVG from 'components/svg/logo';
//
const title = 'Riff Raff Films';
//
export default ({ site }) => {
  let rootPath = '/';
  if (site && typeof site !== 'undefined' && site !== 'uk') {
    rootPath = `/${site}`;
  }

  return (
    <Wrap>
      <Link to={rootPath} title={title}>
        <LogoSVG title={title} />
      </Link>
    </Wrap>
  );
};
//
const Wrap = styled.figure`
  background-color: #fff;
  max-width: 100%;
  width: 200px;

  a {
    display: block;
    padding: 1rem 0.5rem;
  }
`;
